import { createSlice } from '@reduxjs/toolkit';
import {
  addCarHouseSubscription,
  fetchCarHouseSubscriptions,
  editCarHouseSubscription,
  createUserSubscriptionAction,
  getUserSubscriptionsAction,
  updateUserSubscriptionAction,
  cancelSubscriptionAction,
  addCarHouseCreditsAction,
  addUserCreditsAction,
  purchaseVehicleAction,
  editSubscription
} from '../actions/subscriptionsAndCredits-actions';

const initialState = {
  subscriptionsLoading: false,
  subscriptions: [],
  credits: [],
  error: null,
};

const subscriptionsAndCreditsSlice = createSlice({
  name: 'subscriptionsAndCredits',
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    // ** CarHouse Subscriptions **
    builder
      .addCase(addCarHouseSubscription.fulfilled, (state, action) => {
        state.subscriptions.subscriptions.unshift(action.payload);
      })
      .addCase(fetchCarHouseSubscriptions.fulfilled, (state, action) => {
        state.subscriptions = action.payload;
      })
      .addCase(editCarHouseSubscription.fulfilled, (state, action) => {
        const updatedSubscription = action.payload;
        const index = state.subscriptions.subscriptions.findIndex(
          (sub) => sub.id === updatedSubscription.id
        );
        if (index !== -1) {
          state.subscriptions.subscriptions[index] = updatedSubscription;
        }
      })
      .addCase(editSubscription.fulfilled, (state, action) => {
        const updatedSubscription = action.payload;
        const index = state.subscriptions.subscriptions.findIndex(
          (sub) => sub.id === updatedSubscription.id
        );
        if (index !== -1) {
          state.subscriptions.subscriptions[index] = updatedSubscription;
        }
      });

    // ** User Subscriptions **
    builder
      .addCase(createUserSubscriptionAction.fulfilled, (state, action) => {
        state.subscriptions.subscriptions.unshift(action.payload);
      })
      .addCase(getUserSubscriptionsAction.fulfilled, (state, action) => {
        state.subscriptions = action.payload;
      })
      .addCase(updateUserSubscriptionAction.fulfilled, (state, action) => {
        const updatedSubscription = action.payload;
        const index = state.subscriptions.subscriptions.findIndex(
          (sub) => sub.id === updatedSubscription.id
        );
        if (index !== -1) {
          state.subscriptions.subscriptions[index] = updatedSubscription;
        }
      })
      .addCase(cancelSubscriptionAction.fulfilled, (state, action) => {
        const updatedSub = action.payload;
        state.subscriptions = {
          ...state.subscriptions,
          subscriptions: state.subscriptions?.subscriptions.map((sub) =>
            sub.id === updatedSub.id ? updatedSub : sub
          ),
        };
      });

    // ** Credits **
    builder
      .addCase(addCarHouseCreditsAction.fulfilled, (state, action) => {
        const updatedCarHouse = action.payload;
        const index = state.subscriptions.findIndex(
          (carHouse) => carHouse.id === updatedCarHouse.id
        );
        if (index !== -1) {
          state.subscriptions[index] = updatedCarHouse;
        }
      })
      .addCase(addUserCreditsAction.fulfilled, (state, action) => {
        const updatedUser = action.payload;
        const index = state.subscriptions.findIndex(
          (user) => user.id === updatedUser.id
        );
        if (index !== -1) {
          state.subscriptions[index] = updatedUser;
        }
      })
      .addCase(purchaseVehicleAction.fulfilled, (state, action) => {
        const updatedUser = action.payload;
        const index = state.subscriptions.findIndex(
          (user) => user.id === updatedUser.id
        );
        if (index !== -1) {
          state.subscriptions[index] = updatedUser;
        }
      });

    // Pending and Rejected cases
    builder
      .addMatcher(
        (action) => action.type.endsWith('/pending'),
        (state) => {
          state.subscriptionsLoading = true;
          state.error = null;
        }
      )
      .addMatcher(
        (action) => action.type.endsWith('/fulfilled'),
        (state, action) => {
          state.subscriptionsLoading = false;
          state.error = null;
        }
      )
      .addMatcher(
        (action) => action.type.endsWith('/rejected'),
        (state, action) => {
          console.log('Error occurred', action.error.message);
          state.subscriptionsLoading = false;
          state.error = action.error.message;
        }
      );
  },
});

export const subscriptionsAndCreditsActions =
  subscriptionsAndCreditsSlice.actions;

export default subscriptionsAndCreditsSlice;
